import { HttpClient } from '@/shared/infra/http/HttpClient';
import { AuditTrailRepository } from '../../application/ports/AuditTrailRepository';
import { AuditTrailResult } from '../../application/domain/entities/AuditTrailResult';
import { ComposedAuditTrailDto } from '../dto/ComposedAuditTrailDto';
import { ComposedAuditTrailMapper } from '../dto/ComposedAuditTrailMapper';

/**
 * One request, one composition.
 *
 * This used to fetch three endpoints and stitch them together, with the two extra calls each wrapped in
 * an empty `catch`. A caller lacking one permission got a 403 that silently removed a whole section, so a
 * record whose remediation history was fully recorded rendered as though nothing had happened — and the
 * Audit Log screen, composing a different subset, could never agree with this one.
 *
 * The server composes it now and reports the sections it withheld, so there is deliberately **no**
 * try/catch here: a failure is a failure and belongs on screen, not swallowed into a blank section.
 */
export class ApiAuditTrailRepository implements AuditTrailRepository {
  constructor(private readonly httpClient: HttpClient) {}

  async fetchAuditTrail(i9FormId: string, detailedDigitization = false): Promise<AuditTrailResult> {
    const query = detailedDigitization ? '?detailed=true' : '';
    const response = await this.httpClient.get<ComposedAuditTrailDto>(
      `/i9Form/${i9FormId}/audit-trail${query}`,
    );
    return ComposedAuditTrailMapper.toResult(response.data);
  }
}
